import * as yup from "yup";
import sharedValidationSchema from "../../shared/PersonalInformation/validation";

export const validationSchema = sharedValidationSchema.concat(
    yup.object({
        captiveAgent: yup.string().required("Please select if you are a captive agent with any insurance carrier"),
        captiveCarrier: yup.string()
            .when("captiveAgent", {
                is: captiveAgent => captiveAgent === "true",
                then: schema => schema
                    .required("Please select a carrier")
            })
    })
);